import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Button, colors } from '@material-ui/core'
import { Page, Header } from 'components'
import clsx from 'clsx'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'

import useRouter from 'utils/useRouter'
import { useCargoService } from 'hooks/useCargoService'
import { Formulario } from './components'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  aboutAuthor: {
    marginTop: theme.spacing(3),
  },
  aboutProject: {
    marginTop: theme.spacing(3),
  },
  projectCover: {
    marginTop: theme.spacing(3),
  },
  projectDetails: {
    marginTop: theme.spacing(3),
  },
  preferences: {
    marginTop: theme.spacing(3),
  },
  actions: {
    marginTop: theme.spacing(3),
  },
  deleteButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.red[900]} 30%, ${colors.red[800]} 90%)`,
    color: 'white',
  },
}))

export const EditarCargo = (props) => {
  const { route } = props
  const cargoService = useCargoService()
  const router = useRouter()
  const dispatch = useDispatch()
  const classes = useStyles()
  const [dados, setDados] = useState([])

  const idsState = useSelector((state) => state.idsState)
  const [openAlertDelete, setOpenAlertDelete] = useState(false)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  const handleClickOpenAlertDelete = () => {
    setOpenAlertDelete(true)
  }

  const handleCloseAlertDelete = () => {
    setOpenAlertDelete(false)
  }

  useEffect(() => {
    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      } else {
        const fetchDados = async () => {
          const c = await cargoService.listarCargoAsync(idsState.idCargo)
    
          const cargo = {
            id: c.id,
            nome: c.nome,
            sigla: c.sigla,
            descricao: c.descricao,
            permissoes: [],
            usuarios: c.usuarios,
          }
    
          await c.perms.every(async (item) => {
            cargo.permissoes.push(item.id)
          })
          setDados(cargo)
        }
    
        if (route.editar) {
          fetchDados()
        }
      }
    }

  }, [permissoesUsuario, dispatch, idsState.idCargo, route.editar, router])

  const handleDelete = async (event) => {
    event.preventDefault()
    await cargoService.deletarCargo(dados.id)
    await cargoService.listarCargosGlobal()
    router.history.push('/cargos')
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <Formulario editar={route.editar} dados={dados} className={classes.aboutProject} />
      <div className={classes.actions}>
        {!route.editar ? (
          <Button
            form="form-cargo"
            type="submit"
            color="secondary"
            variant="contained"
            style={{ float: 'right' }}
          >
            Cadastrar cargo
          </Button>
        ) : (
          <div>
            <Button
              form="form-cargo"
              type="submit"
              color="secondary"
              variant="contained"
              style={{ float: 'right' }}
            >
              Atualizar
            </Button>
            <Button
              onClick={handleClickOpenAlertDelete}
              variant="contained"
              className={clsx(classes.deleteButton)}
            >
              Excluir
            </Button>
          </div>
        )}
      </div>
      <Dialog
        open={openAlertDelete}
        onClose={handleCloseAlertDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Tem certeza que deseja deletar?</DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseAlertDelete} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleDelete} className={clsx(classes.deleteButton)} autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  )
}
